import { MidnightValue } from '@monorepo/types';
import { useStore } from '@hub/helpers/use-store';
import { useQuery } from '@tanstack/react-query';
import { ACCOUNT_QUERY_KEYS, ACCOUNT_STALE_TIME } from '../constants';

export const useMidnightValuesData = (tsAccountId?: string, enabled = true) => {
  const {
    dataStore: { accountStore },
  } = useStore();

  return useQuery<MidnightValue[]>({
    queryKey: ACCOUNT_QUERY_KEYS.MIDNIGHT_VALUES(tsAccountId || ''),
    queryFn: async () => {
      if (!tsAccountId)
        throw new Error('Trading system account ID is required');

      const midnightValues = await accountStore.getMidnightHistory(tsAccountId);

      if (!midnightValues) {
        throw new Error(
          `Midnight values not found for account: ${tsAccountId}`,
        );
      }

      return midnightValues;
    },
    staleTime: ACCOUNT_STALE_TIME,
    enabled: enabled && !!tsAccountId,
  });
};
